import React from "react";
import "../css/privacy.scss";

function Cookies() {
  return (
    <div className="privacy-page">
      <div className="container">
        <h1>Cookie Policy</h1>
        <div className="content-section">
          <p>
            This policy explains how Cewillow Market uses cookies and similar
            browser storage. Cookies are small files or stored values that help a
            website remember information about a visit.
          </p>
          <div className="policy-block">
            <h3>Essential Storage</h3>
            <p>
              Essential storage supports core functions such as retaining items in
              your cart, security and navigation. The site cannot provide these
              features reliably without it.
            </p>
          </div>
          <div className="policy-block">
            <h3>Performance Technologies</h3>
            <p>
              We may use limited, aggregated performance information to understand
              page reliability and improve the shopping experience. We do not use
              cookies to sell personal information.
            </p>
          </div>
          <div className="policy-block">
            <h3>Your Controls</h3>
            <p>
              Most browsers let you delete or block cookies in their privacy settings.
              Blocking essential storage may prevent the cart and checkout from working.
            </p>
          </div>
          <div className="policy-block">
            <h3>Contact</h3>
            <p>
              Questions may be sent to{" "}
              <a href="mailto:import@cewillowmarket.life">import@cewillowmarket.life</a>.
            </p>
            <p>Last updated: September 22, 2026.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Cookies;
